import { render, staticRenderFns } from "./DeleteInviteUserModal.vue?vue&type=template&id=32ba5e94&lang=pug"
import script from "./DeleteInviteUserModal.vue?vue&type=script&lang=js"
export * from "./DeleteInviteUserModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports